export const FROMDAY = 'FROMDAY'
export const FROMMONTH = 'FROMMONTH'
export const FROMYEAR = 'FROMYEAR'

export const TODAY = 'TODAY'
export const TOMONTH = 'TOMONTH'
export const TOYEAR = 'TOYEAR'

export const SHOWEMAILTYPEBLANK = 'SHOWEMAILTYPEBLANK'
export const SHOWEMAILTYPEUNUSED = 'SHOWEMAILTYPEUNUSED'
export const SHOWEMAILTYPEUSED = 'SHOWEMAILTYPEUSED'
export const SHOWEMAILTYPEJUNK = 'SHOWEMAILTYPEJUNK'
export const SHOWEMAILTYPECOPY = 'SHOWEMAILTYPECOPY'

export const HIDEMARKEDREAD = 'HIDEMARKEDREAD'

export const FLAG_C = 'FLAG_C'
export const FLAG_EN = 'FLAG_EN'
export const FLAG_N = 'FLAG_N'
export const FLAG_RL = 'FLAG_RL'
export const FLAG_TC = 'FLAG_TC'
export const FLAG_TL = 'FLAG_TL'
export const FLAG_AE = 'FLAG_AE'
export const FLAG_PO = 'FLAG_PO'
export const FLAG_HR = 'FLAG_HR'
export const FLAG_RE = 'FLAG_RE'
export const FLAG_ID = 'FLAG_ID'
export const FLAG_PT = 'FLAG_PT'
export const FLAG_PN = 'FLAG_PN'

export const PANELIST = 'PANELIST'

export const STATE = 'STATE'

export const COUNTRY = 'COUNTRY'

export const BUSINESSOWENER = 'BUSINESSOWENER'
export const NON_BUSINESS = 'NON_BUSINESS'
export const OWENER_BOTH = 'OWENER_BOTH'

export const PARTITION = 'PARTITION'

export const ISFROMSEARCH = 'ISFROMSEARCH'

export const RESETSTATES = 'RESETSTATES'

export const SEARCHQUERY = 'SEARCHQUERY'
export const SEARCHID = 'SEARCHID'

export const SEARCHBY = 'SEARCHBY'

export const SEARCHBYID = 'SEARCHBYID'

export const SEARCHBYSUBJECT = 'SEARCHBYSUBJECT'

export const SEARCHBYBODY = 'SEARCHBYBODY'

export const SEARCHBYSENDER = 'SEARCHBYSENDER'
export const PANELIST_TYPE = 'PANELIST_TYPE'

export const SEARCHBYSENDERNAME = 'SEARCHBYSENDERNAME'
export const SEARCHBYSENDEREMAIL = 'SEARCHBYSENDEREMAIL'
